import { render, staticRenderFns } from "./AvailableLabours.vue?vue&type=template&id=92f4bebc&scoped=true"
import script from "./AvailableLabours.vue?vue&type=script&lang=js"
export * from "./AvailableLabours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f4bebc",
  null
  
)

export default component.exports